import { Adapter } from '@fmnts/core';
import { IApiNextFormModal } from '../api-model/api-model';
import { FormNavigationAdapter } from '../model/form-navigation';
import { QuizField } from '../model/quiz-field';
import { QuizPage } from '../model/quiz-page';
import { ApiModalAdapter } from './modal.adapter';
import {
  QuizFieldsetAdapter,
  QuizFieldsetToApiAdapter,
} from './quiz-fieldset.adapter';

export class QuizPageAdapter implements Adapter<QuizPage> {
  constructor(
    private actionAdapter = new FormNavigationAdapter(),
    private modalAdapter = new ApiModalAdapter(),
    private fieldsetAdapter = new QuizFieldsetAdapter(),
  ) {}

  adapt(item: Record<string, any>): QuizPage {
    const fieldsets = ((item['fieldsets'] || []) as Record<string, any>[]).map(
      (fieldset) => this.fieldsetAdapter.adapt(fieldset),
    );
    const navigation = (
      (item['navigation'] || []) as Record<string, any>[]
    ).map((action) => this.actionAdapter.adapt(action));
    const modals = ((item['modals'] || []) as IApiNextFormModal[]).map(
      (modal) => this.modalAdapter.adapt(modal),
    );

    return new QuizPage({
      key: item['key'],
      headerImage: item['header_image'],
      label: item['label'],
      fieldsets,
      navigation,
      modals,
    });
  }
}

export class QuizPageToApiAdapter {
  constructor(private fieldsetAdapter = new QuizFieldsetToApiAdapter()) {}

  adaptModelToDto(quizPage: QuizPage): { [key: string]: any } {
    return {
      key: quizPage.key,
      headerImage: quizPage.headerImage,
      label: quizPage.label,
      fieldsets: quizPage.fieldsets.map((fs) =>
        this.fieldsetAdapter.adaptModelToDto(fs),
      ),
      navigation: quizPage.navigation,
      modals: quizPage.modals,
    };
  }

  adaptFieldToApi(item: QuizField): Record<string, any> {
    const baseProps = {
      key: item.key,
      label: item.label,
      widget: item.widget,
      style: item.style,
      condition: item.condition,
    };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return { ...baseProps, ...item.widgetOptions, ...item.attrs };
  }
}
